<template>
  <div>
    <duplicate-sample-menu />
    <user />
    <notifications-menu />
    <worker-status />
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import DuplicateSampleMenu from './DuplicateSampleMenu.vue';
import NotificationsMenu from './NotificationsMenu.vue';
import { User } from '../user';
import WorkerStatus from '../user/components/WorkerStatus.vue';

export default defineComponent({
  name: 'Admin',
  components: {
    DuplicateSampleMenu,
    NotificationsMenu,
    User,
    WorkerStatus,
  },
});
</script>
